<div class="page-layout simple left-sidebar inner-sidebar inner-scroll">

    <!-- HEADER -->
    <div class="header accent p-6 flex items-center">

        <!-- <button mat-icon-button class="sidebar-toggle mr-8" fxHide.gt-md
                (click)="toggleSidebar('simple-left-sidebar-4')">
            <mat-icon>menu</mat-icon>
        </button> -->

        <div>
            <span class="text-4xl font-semibold">Administración de {{'TEAM_LABEL' | translate}}</span>
        </div>

    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div class="content flex">

        <!-- SIDEBAR -->
        <!-- <fuse-sidebar class="sidebar" name="simple-left-sidebar-4" position="left" lockedOpen="gt-md"> -->

            <!-- SIDEBAR CONTENT -->
            <div class="sidebar p-6 overflow-y-auto">
                <entity-list
                    #entityList
                    title="Lista de {{'TEAM_LABEL_PLURAL' | translate}}"
                    [values]="teams"
                    (entitySelected)="selected($event)" >
                </entity-list>
            </div>
            <!-- / SIDEBAR CONTENT -->

        <!-- DIVISOR -->
        <div class="w-px bg-gray-200"></div>

        <!-- CENTER -->
        <div class="center flex flex-col p-6 flex-grow">
            <!-- TÍTULO -->
            <span class="text-3xl font-semibold mb-4">Datos de {{'TEAM_LABEL' | translate}}</span>

            <!-- BOTÓN NUEVO -->
            <div *ngIf="_systemService.canAction('adminTeams')" class="pb-4 w-[600px] flex justify-end">
                <button mat-raised-button (click)="newTeam()" aria-label="Nuevo equipo">
                    <mat-icon>add</mat-icon>
                    Nuevo
                </button>
            </div>
            <!-- CONTENT -->
            <div class="content p-6">
                <team-form #teamForm (entityChanged)="entityChanged($event)"></team-form>
            </div>
            <!-- / CONTENT -->

        </div>
        <!-- / CENTER -->

    </div>
    <!-- / CONTENT -->

</div>

